var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWibes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -164.3022,
    y1: -27446.4688,
    x2: 18807.3594,
    y2: 4172.9189,
    gradientTransform: "matrix(3.234501e-02 0 0 -3.234501e-02 203.3076 115.5872)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6F01FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF49D7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,469.5C0,305.1,0,223,32,160.2C60.1,105,105,60.1,160.2,32C223,0,305.1,0,469.5,0h61.1 C694.9,0,777,0,839.8,32C895,60.1,939.9,105,968,160.2c32,62.8,32,144.9,32,309.3v61.1c0,164.3,0,246.5-32,309.3 C939.9,895,895,939.9,839.8,968c-62.8,32-144.9,32-309.3,32h-61.1c-164.3,0-246.5,0-309.3-32C105,939.9,60.1,895,32,839.8 C0,777,0,694.9,0,530.5V469.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M761,352.9c-35.8,0-68.2,10.8-95.8,29.4V213h-76.4v312c0,94.9,77.2,171.3,171.7,171.3 c94.5,0,172.6-75.9,172.6-172.2C933.2,427.9,856.8,352.9,761,352.9z M414.3,547.1L344.4,365h-53.5l-70.3,182.1L150.2,365H66.9 l123,320.2h53.5l73.8-190.7l74.2,190.7h53.5L567.5,365h-82.9L414.3,547.1z M760.6,620c-51.8,0-95.4-41.4-95.4-95.4 c0-54,41-94.9,95.8-94.9c54.8,0,95.8,42.7,95.8,94.9C856.8,576.9,813.2,620,760.6,620z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWibes);
export default __webpack_public_path__ + "static/media/wibes.26ee383312b6211bebd17b025418a513.svg";
export { ForwardRef as ReactComponent };